import { App } from './App';
import { GtxMainRender } from 'gtx-react/components/GtxApp/GtxMainRender';

GtxMainRender(App);
